export const actorAddressTypes = Object.freeze({
    billing: 1,
    visiting: 2,
    postal: 3,
    delivery: 4,
    temporary: 5,
    classRoom: 6,
    inactive: 10
});